import * as React from 'react';
import styles from './index.less';
import wrapStore from '@src/utils/wrap-store';
import MechaMoreStore from '@src/pages/mecha/sections/change-more/store';
import cx from 'classnames';
import BaseSwiper from '@src/components/swiper/base-swiper';

const MechaMore = ({ store }) => {
  store.use();
  React.useEffect(
    () => {
      const handleScroll = () => {
        const moreElement = document.getElementById('mecha-more');
        if (moreElement) {
          const rect = moreElement.getBoundingClientRect();
          const isVisible = rect.top >= 0 && rect.bottom <= window.innerHeight;
          if (isVisible && !store.isActive) {
            store.isActive = true;
          }
        }
      };

      window.addEventListener('scroll', handleScroll);
      handleScroll();

      return () => {
        window.removeEventListener('scroll', handleScroll);
      };
    },
    [store.isActive]
  );

  const tabSwiper = () => {
    if (store?.mechaBtnList?.length) {
      return store.mechaBtnList?.map((item, index) => {
        return (
          <div key={index} className={cx(styles.swiperList)}>
            <div className={styles.changeBox} style={{ pointerEvents: 'none', backgroundImage: `url(${item?.btn_image})` }} />
            <div className={cx(styles.changeBox, styles.changeBoxHover)} style={{ pointerEvents: 'none', backgroundImage: `url(${item?.btn_hover_image})` }} />
            {/* <div className={cx(styles.no_active, item.id === store?.mechaStore?.currentMacheId && styles.activeBox)}>
              <div className={styles.listImg} style={{ backgroundImage: `url(${item?.btn_image})` }} />
              <div className={cx(styles.listImg, styles.listImg_hover)} style={{ backgroundImage: `url(${item?.btn_hover_image})` }} />
              <div className={cx(styles.listImg, styles.listImg_active)} style={{ backgroundImage: `url(${item?.btn_active_image})` }} />
            </div> */}

            {/* <div className={cx(styles.tabBox)}>
              <div className={styles.listImg} style={{ backgroundImage: `url(${item?.btn_image})` }} />
              <div className={cx(styles.listImg, styles.listImg_hover)} style={{ backgroundImage: `url(${item?.btn_hover_image})` }} />
              <div className={cx(styles.listImg, styles.listImg_active)} style={{ backgroundImage: `url(${item?.btn_active_image})` }} />
            </div> */}
          </div>
        );
      });
    }
  };

  const handleClick = e => {
    const target = e.target;
    const mecha = store.mechaBtnList[target.getAttribute('data-swiper-slide-index')];
    mecha?.id && store.mechaStore.onClickChangeMecha(mecha.id);
  };

  return (
    <div className={cx(styles.mechaMoreRoot)} id="mecha-more">
      {store.isActive && (
        <div className={styles.listBox} onClick={handleClick}>
          {store?.mechaBtnList?.length && (
            <div className={styles.swiperBox}>
              <BaseSwiper store={store.mechaListSwiper}>{tabSwiper()}</BaseSwiper>
            </div>
          )}

          <div className={styles.leftBtn} data-btn-hover onClick={store.onClickGoPrev}>
            <div className={styles.leftBtnInner1} />
            <div className={styles.leftBtnInner2} />
            <div className={styles.leftBtnInner3} />
          </div>
          <div className={styles.rightBtn} data-btn-hover onClick={store.onClickGoNext}>
            <div className={styles.rightBtnInner1} />
            <div className={styles.rightBtnInner2} />
            <div className={styles.rightBtnInner3} />
          </div>
        </div>
      )}
    </div>
  );
};

export default wrapStore(MechaMore, MechaMoreStore);
